import Modal from "react-bootstrap/Modal";
import SocialCard from "../../../organisms/LeadHistory/SocialCard";
import { SearchResult } from "../../../../slices/leads/types";
import IconHome from "../../../../styles/icons/IconHome";

interface Props {
  onHide: () => void;
  show: boolean;
  header: string;
  bodyHeadline: string;
  bodyContent: string;
  name: string;
  origin: any;
  socialitems: SearchResult | null;
}

const SocialMediaModal = (props: Props) => {
  const { socialitems } = props;

  return (
    <Modal
      {...props}  
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="custom-modal"
    >
      <Modal.Header closeButton className="header">
        <Modal.Title id="contained-modal-title-vcenter" className="title d-flex align-items-center gap-2">
          <IconHome breadcrumb="allLeads" activeColor="#0f1560"/>
          <div className="headline">
            {props.header}
            <p>Public social media activity found for this lead.</p>
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="body">
        <h4>{props.bodyHeadline}</h4>
        <div className="social-card-list">
          {socialitems?.items?.length ? (
            socialitems.items.map((post, index) => (
              <SocialCard key={index} post={post} />
            ))
          ) : (
            <p>No social media matches found</p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SocialMediaModal;
